<script>
    export let kind;
    export let title;
    export let description;

    let collapsed;

    function toggleCollapse () {
        collapsed = !collapsed;
    }
</script>

<style>
    .topic-margin {
        margin: 15px 45px;
    }

    @media (max-width: 767px) {
        .topic-margin {
            margin: 15px 20px;
        }
    }

    @media (max-width: 440px) {
        .topic-margin {
            margin: 15px 0;
        }
    }

    h5 {
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 8px;
    }

    .topic-metadatum {
        line-height: 20px;
        overflow: hidden;
        font-size: 12px;
    }

    .topic-metadatum.brief {
        max-height: 40px;
    }
</style>

<div class="topic-margin">
    <h5>{kind}: {title}</h5>
    <div class="topic-metadatum" class:brief={collapsed}>
        {@html description}
    </div>

    <div class="text-center">
        <button class="flat flat-secondary" on:click={toggleCollapse}>
            {collapsed ? "View more" : "View less"}
        </button>
    </div>
</div>

